<template>
<div>
   <div class="scroll-rating-tagging" id="scroll-rating-tagging" ref="scroll-rating-tagging">    
   </div>
</div>
</template>
<script> 
  import { AnalyticsHandler } from '@Foundation/analyticsHandler';
  export default {
    name: 'scroll-rating',
    props: {
      taggingData: { type: Object, required: false },      
    },
     data() {
      return {
        isTrigger: true,
        };
    }, 
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        this.bindelement();           
     },    
    methods: {
      bindelement(){
        if(document.querySelectorAll('.rfp-rr-most-ratings-list-097-or')!=''){ 
          let reviewdata = document.querySelectorAll('.rfp-rr-most-ratings-list-097-or');
            for(let i = 0; i < reviewdata.length; i++) {              
                  reviewdata[i].setAttribute("id", "rfp-rr-rating-list-item-"+i);             
            }
        }
      }, 
      handleScroll(){  
           this.bindelement(); 
           const observer = new IntersectionObserver(entries => {
               entries.forEach(entry => {
                if(this.isTrigger){
                   const intersecting = entry.isIntersecting 
                    if(intersecting){               
                        AnalyticsHandler.pushDataLayer({ ...this.taggingData});
                        this.isTrigger= false;
                    }
                }
               })
          })
          if(document.querySelectorAll('.rfp-rr-most-ratings-list-097-or') !='')
           {
               let revieDataLength=document.querySelectorAll('.rfp-rr-most-ratings-list-097-or');
               if(revieDataLength.length >=2 ){
                    observer.observe(document.getElementById("rfp-rr-rating-list-item-1"));
               }else if(revieDataLength.length == 1){
                     observer.observe(document.getElementById("rfp-rr-rating-list-item-0"));
               }
           }else{
              observer.observe(document.getElementById("scroll-rating-tagging"));
           }
          
      },
    }
  };
</script>
